import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { fromStore } from '../selectors';
import { request } from '../utils';

const shopData = {
  name: 'Sushibox',
  company: 'ООО "Южный Берег"',
  url: 'https://situshibox.kz',
};

export default function YMLPage() {
  const categories = useSelector(fromStore.denormalizedCategories);
  const [offers, setOffers] = useState(null);

  const escapeXML = (str) => {
    if (!str) return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  };

  const downloadXML = () => {
    let xmlContent = '<?xml version="1.0" encoding="UTF-8"?>\n';
    xmlContent += `<yml_catalog date="${dayjs().format()}">\n`;
    xmlContent += '<shop>\n';
    xmlContent += `<name>${escapeXML(shopData.name)}</name>\n`;
    xmlContent += `<company>${escapeXML(shopData.company)}</company>\n`;
    xmlContent += `<url>${shopData.url}</url>\n`;
    xmlContent += '<currencies>\n';
    xmlContent += '<currency id="KZT" rate="1"/>\n';
    xmlContent += '</currencies>\n';
    xmlContent += '<categories>\n';

    categories.forEach((category) => {
      xmlContent += `<category id="${category.id}">${escapeXML(category.title)}</category>\n`;
    });

    xmlContent += '</categories>\n';
    xmlContent += '<offers>\n';

    offers.forEach((item) => {
      xmlContent += `<offer id="${item.id}" available="true">\n`;
      xmlContent += `<url>${item.url}</url>\n`;
      xmlContent += `<name>${escapeXML(item.name)}</name>\n`;
      xmlContent += `<price>${item.price}</price>\n`;
      xmlContent += '<currencyId>KZT</currencyId>\n';
      if (item.oldPrice && item.oldPrice > item.price) xmlContent += `<oldprice>${item.oldPrice}</oldprice>\n`;
      xmlContent += `<categoryId>${item.categoryId}</categoryId>\n`;
      xmlContent += `<picture>${item.picture ? item.picture : ''}</picture>\n`;
      if (item.description) xmlContent += `<description>${escapeXML(item.description)}</description>\n`;
      xmlContent += '</offer>\n';
    });

    xmlContent += '</offers>\n';
    xmlContent += '</shop>\n';
    xmlContent += '</yml_catalog>';

    const blob = new Blob([xmlContent], { type: 'application/xml;charset=utf-8' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'catalog.yml';
    link.click();
    URL.revokeObjectURL(link.href);
  };

  useEffect(() => {
    const getGoods = async () => {
      const goods = await request({ method: 'get', url: '/items_yml' });
      const result = goods.map((item) => ({
        id: item.id,
        name: item.name,
        available: true,
        url: item.link,
        price: typeof item.price === 'string' ? parseFloat(item.price.replace(/\s/g, '')) || 0 : item.price,
        oldPrice: typeof item.oldPrice === 'string' ? parseFloat(item.oldPrice.replace(/\s/g, '')) || null : item.oldPrice,
        categoryId: item.category,
        description: item.description,
        picture: item.image ? item.image : null,
      }));

      setOffers(result);
    };

    getGoods();
  }, []);

  useEffect(() => {
    if (offers) downloadXML();
  }, [offers]);

  return (
    <div />
  );
}
